/**
 * Hook TanStack Form para el diálogo de motivo de baja (ORR-404).
 * Mismo patrón que `useAutoDelegarAfipForm`: schema Zod en `validators.onSubmit`
 * y ejecución delegada al `onSubmit` que llega por options.
 */
import { useForm } from '@tanstack/react-form'

import { motivoBajaSchema, type MotivoBajaFormValues } from './motivoBajaSchema'

export interface UseMotivoBajaFormOptions {
  onSubmit?: (values: MotivoBajaFormValues) => void | Promise<void>
}

// `motivo` arranca vacío para que nadie dé de baja con el primero de la lista sin mirarlo;
// el schema lo rechaza hasta que se elige uno.
const DEFAULT_VALUES = {
  motivo: '' as MotivoBajaFormValues['motivo'],
  detalle: null,
} satisfies MotivoBajaFormValues

export function useMotivoBajaForm(options: UseMotivoBajaFormOptions = {}) {
  const { onSubmit } = options

  const form = useForm({
    defaultValues: { ...DEFAULT_VALUES } as MotivoBajaFormValues,
    validators: {
      onSubmit: motivoBajaSchema,
    },
    onSubmit: async ({ value }) => {
      if (onSubmit) {
        await onSubmit(value)
      }
    },
  })

  return { form }
}

export type UseMotivoBajaFormReturn = ReturnType<typeof useMotivoBajaForm>
export type MotivoBajaForm = UseMotivoBajaFormReturn['form']
